import { Injectable } from '@angular/core';

/** Runtime configuration fetched from the backend at startup (GET /api/config). */
export interface AppConfig {
  msal: {
    clientId: string;
    authority: string;
  };
  apiScopes: string[];
  icare: {
    personUrl: string;
    buildingUrl: string;
    damageUrl: string;
    documentUrl: string;
  };
}

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private config: AppConfig | null = null;

  /** Same-origin backend base URL; the Spring app serves both the SPA and the API. */
  get apiBaseUrl(): string {
    return window.location.origin;
  }

  /**
   * Loads the runtime config before the app bootstraps. Uses the native fetch API on purpose,
   * so the request bypasses the MSAL HTTP interceptor (whose configuration depends on this very
   * config) and avoids a bootstrap ordering cycle.
   */
  async load(): Promise<void> {
    const response = await fetch(`${this.apiBaseUrl}/api/config`);
    if (!response.ok) {
      throw new Error(`Failed to load application config: ${response.status} ${response.statusText}`);
    }
    this.config = await response.json();
  }

  get current(): AppConfig {
    if (!this.config) {
      throw new Error('Application config has not been loaded yet.');
    }
    return this.config;
  }
}
